"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.BehaviourStatesPerDay = void 0;
var BehaviourStatesPerDay = /** @class */ (function (_super) {
    __extends(BehaviourStatesPerDay, _super);
    function BehaviourStatesPerDay() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._typeName = "BehaviourStatesPerDay";
        _this.date = function () {
            _this.push(function (_) { return "date"; });
        };
        _this.running = function () {
            _this.push(function (_) { return "running"; });
        };
        _this.success = function () {
            _this.push(function (_) { return "success"; });
        };
        _this.waiting = function () {
            _this.push(function (_) { return "waiting"; });
        };
        _this.failed = function () {
            _this.push(function (_) { return "failed"; });
        };
        _this.render = function (registry) { return _this.map(function (e) { return e(registry); }).join(" "); };
        return _this;
    }
    return BehaviourStatesPerDay;
}(Array));
exports.BehaviourStatesPerDay = BehaviourStatesPerDay;
//# sourceMappingURL=BehaviourStatesPerDay.js.map